import { BrowserStorage } from '@common/enums';

export function tokenGetter() {
  try {
    return JSON.parse(localStorage.getItem(BrowserStorage.Prefix + BrowserStorage.Token));
  } catch (e) {
    return null;
  }
}
